module.exports = __webpack_public_path__ + "img/img1.6ead7115.png";